/**
 * Resolve display identity for the SRE workbench header from a Pulse ticket/case.
 * Prefer Alert.source (Alerts list Source column) over intake channel (web/email/alert).
 */

type AlertSourceFields = {
  source?: string | null;
};

export function resolveTicketAlertSource(ticket: {
  Alert?: AlertSourceFields | AlertSourceFields[] | null;
  ReferenceAlert?: AlertSourceFields | null;
}): string | undefined {
  const alerts = Array.isArray(ticket.Alert)
    ? ticket.Alert
    : ticket.Alert
      ? [ticket.Alert]
      : [];
  const fromLinked = alerts
    .map((alert) => (alert?.source || '').trim())
    .find(Boolean);
  if (fromLinked) return fromLinked;
  const fromReference = (ticket.ReferenceAlert?.source || '').trim();
  return fromReference || undefined;
}
